export enum SolarSubTechnology {
  GROUND_MOUNTED = 'GROUND_MOUNTED',
  BUILDING_MOUNTED = 'BUILDING_MOUNTED',
  FLOATING = 'FLOATING',
  AGRI_PV = 'AGRI_PV',
  MOOR = 'MOOR',
}
export const solarSubTechnologyToLabel = {
  [SolarSubTechnology.GROUND_MOUNTED]: 'Ground Mounted-PV',
  [SolarSubTechnology.BUILDING_MOUNTED]: 'Rooftop-PV',
  [SolarSubTechnology.FLOATING]: 'Floating-PV',
  [SolarSubTechnology.AGRI_PV]: 'Agri-PV',
  [SolarSubTechnology.MOOR]: 'Moor-PV',
};
